import {
  AgreementIcon,
  AnalysisIcon,
  ModelingIcon,
  ResultIcon,
  TransferIcon,
} from './WorkflowIcons';
import HomeSectionAccordion from '../HomeSectionAccordion/HomeSectionAccordion';
import './style.css';

const steps = [
  {
    title: 'Передача данных',
    icon: TransferIcon,
  },
  {
    title: 'Анализ и уточнение требований',
    icon: AnalysisIcon,
  },
  {
    title: 'Согласование объёма и сроков',
    icon: AgreementIcon,
  },
  {
    title: 'Моделирование и документация',
    icon: ModelingIcon,
  },
  {
    title: 'Передача результатов',
    icon: ResultIcon,
  },
];

const Workflow = () => {
  return (
    <section className="section workflow" id="process">
      <div className="container">
        <div className="workflow__wrapper">
          <div className="workflow__frame">
            <HomeSectionAccordion
              id="process"
              title="Подход к работе"
              collapsedSummary="Пять этапов работы — от передачи данных до готового результата."
            >
              <div className="workflow__grid">
              {steps.map(({ title, icon: Icon }, index) => (
                <article key={title} className="workflow__card">
                  <div className="workflow__badge">{index + 1}</div>
                  <div className="workflow__icon">
                    <Icon />
                  </div>
                  <h2 className="workflow__card-title">{title}</h2>
                </article>
              ))}
              </div>

              <div className="workflow__notes">
              <p className="workflow__note">
                Работы выполняются в рамках согласованного объёма и требований к точности.
              </p>
              <p className="workflow__note">Корректировки вносятся по замечаниям заказчика.</p>
              </div>
            </HomeSectionAccordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Workflow;
